import { useTheme } from '@mui/material'
import React from 'react'
import { DaysDisengagedIcon } from 'src/designSystem/icons'
import { AppActivityLevel } from 'src/graphql.generated'
import IndicatorChip from './IndicatorChip'

type Props = {
  days: number
  level: AppActivityLevel
  expanded?: boolean
}

const DaysDisengagedIndicator = ({ days, level, expanded = false }: Props) => {
  const { palette } = useTheme()
  const levelColor: Record<AppActivityLevel, string> = {
    [AppActivityLevel.Engaged]: palette.severityLow,
    [AppActivityLevel.Inactive]: palette.severityMedium,
    [AppActivityLevel.Dormant]: palette.severityHigh,
  }

  return (
    <IndicatorChip
      tooltip={`${days} days disengaged`}
      label={expanded ? 'Days disengaged' : undefined}
      color={levelColor[level]}
      testId="days-disengaged-indicator"
    >
      <DaysDisengagedIcon days={days} color={levelColor[level]} />
    </IndicatorChip>
  )
}

export default DaysDisengagedIndicator
